import React, { Fragment, useState } from "react";
import { EuiHealth, EuiInMemoryTable, EuiSpacer } from "@elastic/eui";
import { useEffect } from "react";
import OrganizationService from "../../services/organization-service";
import TrunkCreate from "./TrunkCreate";

const TrunkTable = (props) => {
  const [trunks, setTrunks] = useState([]);

  const [isModalVisible, setIsModalVisible] = useState(false);
  const [modalLicenses, setModalLicenses] = useState([]);
  const [loading, setLoading] = useState(true);
  const [isClosed, setIsClosed] = useState(true);
  const [errorMessage, setErrorMessage] = useState("");

  const toggleIsClosed = () => setIsClosed((prevState) => !prevState);

  useEffect(() => {
    setErrorMessage("");
    setLoading(true);
    const organizationId = props.data.company;
    const token = sessionStorage.getItem("krakenT");
    OrganizationService.getTrunksByPowershell({ token, organizationId })
      .then(({ data: { data: trunks } }) => {
        setTrunks(trunks);
        setLoading(false);
      })
      .catch((error) => {
        console.log(error);
        setErrorMessage("Access denied");
        setLoading(false);
      });
  }, [props, isClosed]);

  //   const extensionClicked = (item) => {
  //     console.log(item);
  //     props.setEditData(item);
  //     props.openFlyoutEdit();
  //   };

  //   const actions = [
  //     {
  //       name: "Edit",
  //       description: "Click here to edit user",
  //       icon: "documentEdit",
  //       type: "icon",
  //       onClick: (item) => extensionClicked(item),
  //     },
  //   ];

  const columns = [
    {
      field: "Identity",
      name: "Identity",
      sortable: true,
      truncateText: true,
    },
    {
      field: "Description",
      name: "Description",
      sortable: true,
      truncateText: true,
    },
    {
      field: "Fqdn",
      name: "Fqdn",
      sortable: true,
      truncateText: true,
    },
    {
      field: "SipSignalingPort",
      name: "SipSignalingPort",
      sortable: true,
      truncateText: true,
    },
    {
      field: "ForwardCallHistory",
      name: "ForwardCallHistory",
      render: (status) => {
        if (status === "True") {
          return <EuiHealth color="success"></EuiHealth>;
        } else {
          return <EuiHealth color="danger"></EuiHealth>;
        }
      },
      sortable: true,
      truncateText: true,
    },
    {
      field: "ForwardPai",
      name: "ForwardPai",
      render: (status) => {
        if (status === "True") {
          return <EuiHealth color="success"></EuiHealth>;
        } else {
          return <EuiHealth color="danger"></EuiHealth>;
        }
      },
      sortable: true,
      truncateText: true,
    },
    {
      field: "SendSipOptions",
      name: "SendSipOptions",
      render: (status) => {
        if (status === "True") {
          return <EuiHealth color="success"></EuiHealth>;
        } else {
          return <EuiHealth color="danger"></EuiHealth>;
        }
      },
      sortable: true,
      truncateText: true,
    },
    {
      field: "MaxConcurrentSessions",
      name: "MaxConcurrentSessions",
      sortable: true,
      truncateText: true,
    },
    {
      field: "Enabled",
      name: "Enabled",
      render: (status) => {
        if (status === "True") {
          return <EuiHealth color="success"></EuiHealth>;
        } else {
          return <EuiHealth color="danger"></EuiHealth>;
        }
      },
      sortable: true,
      truncateText: true,
    },
  ];

  const search = {
    box: {
      incremental: true,
      schema: true,
    },
  };

  return (
    <Fragment>
      <TrunkCreate props={props} closeModalProp={toggleIsClosed} />
      <EuiSpacer size="l" />
      <EuiInMemoryTable
        message={
          loading
            ? "Loading ..."
            : errorMessage
            ? errorMessage
            : "No items found"
        }
        loading={loading}
        tableCaption="Trunk List"
        items={trunks}
        columns={columns}
        search={search}
        pagination={true}
        sorting={true}
      />
    </Fragment>
  );
};

export default TrunkTable;
